export const uploadFiles = (file, successFunction) => {
  const csrf = document.querySelector("meta[name='csrf-token']").getAttribute('content');

  let formData = new FormData();
  formData.append('file', file);

  fetch(`/api/v1/upload_files`, {
    method: 'POST',
    headers: {
      // 'Content-Type': 'multipart/form-data',
      'X-CSRF-Token': csrf,
    },
    body: formData,
  })
    .then((response) => response.json())
    .then((data) => {
      successFunction(data);
    });
};
